import React, { useEffect } from 'react'
import parse from 'html-react-parser';
import { Script } from 'gatsby';

const AdvocacyEmbed = ({ block }) => {
  const parsed = (block?.dynamicContent) ? parse(block.dynamicContent) : null
  const advocacyId = (parsed?.props?.id) ? (parsed.props.id) : null

  const addLink = url => {
    const link = document.createElement("link")
    link.href = url
    link.rel="stylesheet"
    document.head.appendChild(link)
  }
     
  useEffect(() => {
    addLink("https://widget-prod-files.global.ssl.fastly.net/ocp-widget.css")
  }, [])

  return (
    advocacyId && (
      <div id="advocacy-code">
        <one-click-widget cid={advocacyId} language="en" env="production" />
        <Script src="https://widget-prod-files.global.ssl.fastly.net/ocp-widget.js" type="module" />
      </div>
    )
  )
}


export default AdvocacyEmbed

